$(document).ready(function(){
  $('.punch-die-slider').slick({
    infinite: false,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,
    autoplay: false,
    accessibility: false,
    arrows: false,
  });
  
   $('.set-options a[data-slide]').on('click touch', function(e) {
   	e.preventDefault();
    $('.set-options a[data-slide]').css('background','#f04c23'); 
   	$(this).css('background','#08381e'); 
     var slideno = $(this).data('slide');
   	$('.punch-die-slider').slick('slickGoTo', slideno - 1);
     
   });
  
  $('.punch-die-slider').on('swipe', function(event, slick, direction){
    $('.set-options a[data-slide]').css('background','#f04c23');
    
    var slideno = $('.punch-die-slider').slick('slickCurrentSlide');
    slideno = slideno + 1;
    
    $('.set-options a[data-slide="' + slideno + '"]').css('background','#08381e'); 

  });
  
});